import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  inject,
  Input,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { PASSANGER_TYPE } from '@univacity/shared/types';

@Component({
  selector: 'un-passangers-input',
  templateUrl: './passangers-input.component.html',
  styleUrls: ['./passangers-input.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PassangersInputComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class PassangersInputComponent implements ControlValueAccessor {
  @Input() disabled: boolean;
  @Input() formControlName?: string;
  @Input() placeholder?: string;
  @Input() hideInfact?: boolean;
  @Input() infoText?: string;
  @Input() hideStudent?: boolean;

  PASSANGER_TYPE = PASSANGER_TYPE;

  private fb = inject(FormBuilder);
  form = this.fb.group({
    adult: 0,
    infant: 0,
    child: 0,
    student: 0,
  });

  get showPlacehoder() {
    const { adult, infant, child, student } = this.form.value;
    return !((adult || 0) + (student || 0) + (infant || 0) + (child || 0));
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  propagateChange = (_: any) => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  propagateTouched = () => {};

  writeValue(obj: any): void {
    // throw new Error('Method not implemented.');
    if (obj) this.form.patchValue(obj);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.propagateTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  incr(p: PASSANGER_TYPE) {
    const v = this.form.controls[p].value || 0;
    this.form.patchValue({ [p]: v + 1 });
    this.propagateChange(this.form.value);
  }
  decr(p: PASSANGER_TYPE) {
    const v = this.form.controls[p].value || 0;

    if (v <= 0) return;

    this.form.patchValue({ [p]: v - 1 });
    this.propagateChange(this.form.value);
  }
}
